import styled, { CSSObject } from '@emotion/styled'
import { StyledHTMLElement } from 'shop/theme/types'

interface Props {
  quantity: number
}

const Quantity = ({ quantity }: Props): JSX.Element => {
  return (
    <Content data-testid='quantity'>
      <Quant>{quantity}x</Quant>
    </Content>
  )
}

const Content = styled.div<StyledHTMLElement>(
  (): CSSObject => ({
    justifySelf: 'left'
  })
)

const Quant = styled.strong<StyledHTMLElement>(({ theme }) => ({
  fontSize: theme.fontSizes[2],
  fontWeight: 500
}))

export default Quantity
